import { get } from 'lodash';
import { createPropsSelectorOrm } from '../utils';

export const getParcelData = createPropsSelectorOrm((session, parcelCode) =>
  get(session.Parcel.withId(parcelCode), 'ref')
);
